import { render } from "./SuccessDialog.vue?vue&type=template&id=4d0f66ee&scoped=true"
import script from "./SuccessDialog.vue?vue&type=script&lang=js"
export * from "./SuccessDialog.vue?vue&type=script&lang=js"

import "./SuccessDialog.vue?vue&type=style&index=0&id=4d0f66ee&lang=scss&scoped=true"

import exportComponent from "/app/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d0f66ee"]])

export default __exports__